export default __webpack_public_path__ + "static/media/stat-logo-color.5ad534e9.svg";